import { WalletDetailsResponse } from "../../@types/Wallet";
import { api } from "../api";

export default async function getWalletDetails(): Promise<WalletDetailsResponse | null> {
  try {
    const response = await api.get("/user/wallet");

    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);

    return null;
  }
}
